import React, { Dispatch, FC } from 'react';
import {
  checkBusinessType,
  handleLocationInputValue,
  removeUSCountryNames,
} from '@src/utils';
import { setSupervisorApprove } from '@store/slices/locations/locationsSlice';
import { useAppDispatch } from '@store/hooks';
import { ToggleLocationModelType } from '@uikit/FormItems/constants';
import { PlusIcon } from '@svg/PlusIcon';
import TruncatedText from '@component/TruncatedText/TruncatedText';

type TypeSelectedAddress = {
  id?: string;
  Icon?: any;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  // city?: selectItemType;
  // state?: selectItemType;
  // zipCode?: selectItemType;
  businessName?: string;
};

export type LocationVariantType = 'auxilium' | 'member';

type TypeLocationSelectItem = {
  title: string;
  hasIcon?: boolean;
  noText?: string;
  data: any[];
  handleSelectVerifiedAddress: (
    e: any,
    el: TypeSelectedAddress,
    whichLocation?: LocationVariantType
  ) => void;
  handleAddressSelection: (e: any) => void;
  whichLocation?: LocationVariantType;
  setToggleLocationModal: Dispatch<ToggleLocationModelType>;
  isInModal?: boolean;
  dataTestId?: string;
};
/*TODO do not forget to move this to styles*/
const buttonStyles = {
  height: '30px',
  padding: '0 12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Plus Jakarta Sans',
  fontSize: '14px',
  lineHeight: '22px',
  fontWeight: '400',
  color: '#FFFFFF',
  background: '#4F7EFF',
  opacity: 1,
  border: 'none',
  borderRadius: '8px',
  gap: '6px',
  whiteSpace: 'nowrap',
};

export const LocationSelectItem: FC<TypeLocationSelectItem> = ({
  title,
  hasIcon = true,
  handleSelectVerifiedAddress,
  data,
  noText = 'No locations found with the given criteria',
  whichLocation,
  setToggleLocationModal,
  isInModal = false,
  handleAddressSelection,
  dataTestId,
}) => {
  const dispatch = useAppDispatch();
  return (
    <div
      data-test-id="c-location-select-item"
      className="location-select__item"
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3 className="location-select__item-title">{title}</h3>
        {!isInModal && (
          <button
            data-test-id="c-location-select-item-add-button"
            style={buttonStyles}
            type="button"
            onClick={() => {
              setToggleLocationModal({ toggle: true, address: null });
              dispatch(setSupervisorApprove(true));
            }}
          >
            <PlusIcon width={16} height={16} />
            Add Address
          </button>
        )}
      </div>
      <div className="options">
        {data?.length ? (
          data.map((el, index) => {
            const combinedAddress = el.formattedAddress
              ? `${checkBusinessType(el.types, el.displayName) ? checkBusinessType(el.types, el.displayName) + ', ' : ''} ${removeUSCountryNames(el.formattedAddress)}`
              : handleLocationInputValue([
                  el.businessName,
                  el.address1,
                  el.address2,
                  el.city,
                  el.state,
                  el.zipCode,
                ]);
            return (
              <button
                type="button"
                data-test-id="c-location-select-item"
                key={index}
                onClick={(e) =>
                  el.formattedAddress
                    ? handleAddressSelection(el)
                    : handleSelectVerifiedAddress(e, el)
                }
                style={{ display: 'flex', gap: '10px' }}
              >
                {hasIcon && <el.Icon />}
                {el.formattedAddress && (
                  <span
                    style={{
                      flexShrink: '0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '25px',
                      height: '25px',
                      backgroundColor: 'white',
                    }}
                  >
                    <img
                      src={el.svgIconMaskURI}
                      alt={el.name}
                      style={{ width: '22px', height: '22px' }}
                    />
                  </span>
                )}
                <span
                  style={{
                    textAlign: 'left',
                    width: '100%',
                    minWidth: 0,
                  }}
                >
                  <TruncatedText
                    text={combinedAddress}
                    dataTestId={`${dataTestId}-${index}`}
                  />
                </span>
              </button>
            );
          })
        ) : (
          <p style={{ padding: '10px 0 2px', fontSize: '14px' }}>{noText}</p>
        )}
      </div>
    </div>
  );
};
